"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function default_1(path, base) {
  return new URL(path, base).toString();
}

exports.default = default_1;